module.exports = __webpack_public_path__ + "static/img/logo_en.fdc3536.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_en.png
// module id = ktps
// module chunks = 33